import { SxProps, Theme } from '@mui/material';

export const stylesBoxChoice: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  border: 1,
  borderRadius: 1,
  borderColor: 'primary.light',
  p: 3,
  '&:hover': {
    cursor: 'pointer',
  },
};
export const stylesBoxChoiceText = {
  fontFamily: 'Poppins',
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: 'normal',
};
